<div class="modal-header">
    <h4 class="modal-title pull-left">
        {{itemToSave?.id ? "Modification " + title : "Enregistrement " + title}}
    </h4>
    <button mat-icon-button class="pull-right" (click)="bsModalRef.hide()" aria-label="Close dialog">
        <mat-icon>close</mat-icon>
    </button>
</div>

<div class="modal-body" [ngBusy]="{
    busy: busySave,
    message: 'Veuillez patienter ...',
    backdrop: false
}">
    <form class="m-1">
        <div class="table-responsive">
            <table class="table table-condensed">
                <thead>
                    <tr>
                        <td colspan="15">
                            <!-- Mode session (brouillon wizard) -->
                            <div *ngIf="currentData?.sessionMode" class="row align-items-end">
                                <div class="col-xl-4 col-lg-4 col-md-6 col-sm-12 mb-2">
                                    <label for="temp_college_id">
                                        Collège (brouillon) <span class="required_champs">*</span>
                                    </label>
                                    <ng-select
                                        [(ngModel)]="itemToSave.temp_college_id"
                                        placeholder="Choisissez un collège"
                                        name="temp_college_id"
                                        id="temp_college_id"
                                        [multiple]="false"
                                        [closeOnSelect]="true">
                                        <ng-option *ngFor="let item of itemsTempCollege" [value]="item.id">
                                            {{item?.libelle}}
                                        </ng-option>
                                    </ng-select>
                                </div>
                                <div class="col-xl-8 col-lg-8 col-md-6 col-sm-12 mb-2">
                                    <small class="text-muted">
                                        <i class="fa fa-info-circle me-1"></i>
                                        Mode brouillon : les bénéficiaires seront ajoutés au collège temporaire sélectionné.
                                    </small>
                                </div>
                            </div>

                            <!-- Toggle colonnes optionnelles -->
                            <div class="d-flex justify-content-end mb-2">
                                <button type="button"
                                    class="btn btn-sm btn-outline-secondary"
                                    (click)="showExtraColumns = !showExtraColumns">
                                    <i class="fa" [class.fa-eye]="!showExtraColumns" [class.fa-eye-slash]="showExtraColumns"></i>
                                    {{ showExtraColumns ? 'Masquer champs optionnels' : 'Afficher champs optionnels' }}
                                </button>
                            </div>

                            <!-- Mode normal -->
                            <div *ngIf="!currentData?.sessionMode" class="row">
                                <!-- Garant -->
                                <div class="col-xl-2 col-lg-2 col-md-3 col-sm-6 mb-2">
                                    <label for="garant_id">
                                        Garant <span class="required_champs">*</span>
                                    </label>
                                    <ng-select
                                        [disabled]="isAutoFill || itemToSave.isAddBeneficiaire"
                                        (change)="onSelectGarant()"
                                        [(ngModel)]="itemToSave.garant_id"
                                        placeholder="Choisissez"
                                        name="garant_id"
                                        id="garant_id"
                                        [multiple]="false"
                                        [closeOnSelect]="true">
                                        <ng-option *ngFor="let item of itemsGarant;" [value]="item.id">
                                            {{item?.libelle}}
                                        </ng-option>
                                    </ng-select>
                                </div>

                                <!-- Police -->
                                <div class="col-xl-2 col-lg-2 col-md-3 col-sm-6 mb-2">
                                    <label for="police_id">
                                        Police <span class="required_champs">*</span>
                                    </label>
                                    <ng-select
                                        [disabled]="isAutoFill"
                                        (change)="onSelectPolice()"
                                        [(ngModel)]="itemToSave.police_id"
                                        placeholder="Choisissez"
                                        name="police_id"
                                        id="police_id"
                                        [multiple]="false"
                                        [closeOnSelect]="true">
                                        <ng-option *ngFor="let item of itemsPolice;" [value]="item.id">
                                            {{item?.libelle}}
                                        </ng-option>
                                    </ng-select>
                                </div>

                                <!-- Collège -->
                                <div class="col-xl-2 col-lg-2 col-md-3 col-sm-6 mb-2">
                                    <label for="college_id">
                                        Collège <span class="required_champs">*</span>
                                    </label>
                                    <ng-select
                                        [disabled]="isAutoFill"
                                        [(ngModel)]="itemToSave.college_id"
                                        placeholder="Choisissez"
                                        name="college_id"
                                        id="college_id"
                                        [multiple]="false"
                                        [closeOnSelect]="true">
                                        <ng-option *ngFor="let item of itemsCollege;" [value]="item.id">
                                            {{item?.libelle}}
                                        </ng-option>
                                    </ng-select>
                                </div>

                                <!-- Avenant -->
                                <div class="col-xl-4 col-lg-4 col-md-3 col-sm-6 mb-2 position-relative">
                                    <label for="avenant_id">
                                        Avenant <span class="required_champs">*</span>
                                    </label>
                                    <div class="d-flex">
                                        <ng-select
                                            [(ngModel)]="itemToSave.avenant_id"
                                            placeholder="Choisissez"
                                            name="avenant_id"
                                            id="avenant_id"
                                            [multiple]="false"
                                            [closeOnSelect]="true"
                                            class="flex-grow-1">
                                            <ng-option *ngFor="let item of itemsAvenant;" [value]="item.id">
                                                {{item?.libelle}}
                                            </ng-option>
                                        </ng-select>
                                        <button
                                            type="button"
                                            (click)="openAddAvenant({police_id: itemToSave.police_id})"
                                            class="btn btn-success rounded-circle ms-2"
                                            style="width: 40px; height: 40px; padding: 0;"
                                            aria-label="Ajouter avenant">
                                            <i class="fa fa-plus"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </td>
                    </tr>

                    <tr class="custom-table-head">
                        <th style="width:36px">#</th>
                        <th *ngIf="showExtraColumns" style="min-width:80px">Famille</th>
                        <th style="min-width:160px">Nom</th>
                        <th style="min-width:160px">Prénom</th>
                        <th style="min-width:70px">Genre</th>
                        <th style="min-width:80px">Statut</th>
                        <th *ngIf="showExtraColumns" style="min-width:110px">Affections</th>
                        <th style="min-width:130px">Assuré</th>
                        <th *ngIf="showExtraColumns" style="min-width:120px">N° CNAM</th>
                        <th style="min-width:120px">Date naissance</th>
                        <th style="min-width:120px">Date entrée</th>
                        <th style="min-width:110px">Téléphone</th>
                        <th *ngIf="showExtraColumns" style="min-width:140px">Email</th>
                        <th *ngIf="showExtraColumns" style="min-width:140px">Email 2</th>
                        <th style="min-width:80px">Photo</th>
                        <th style="width:44px"></th>
                    </tr>
                </thead>

                <tbody>
                    <tr *ngFor="let item of itemsToSaveBenef; let i = index;">
                        <td class="text-center" style="color:#9ca3af;font-size:.8rem;">{{i + 1}}</td>

                        <!-- Famille (masqué par défaut) -->
                        <td *ngIf="showExtraColumns">
                            <input type="text" disabled
                                [ngModelOptions]="{standalone: true}"
                                class="form-control custom-input"
                                placeholder="Famille"
                                [(ngModel)]="item.regroupement_famille" />
                        </td>

                        <!-- Nom -->
                        <td>
                            <input type="text"
                                [ngModelOptions]="{standalone: true}"
                                class="form-control custom-input"
                                style="min-width:150px"
                                placeholder="Nom"
                                autocomplete="off"
                                [(ngModel)]="item.nom" />
                        </td>

                        <!-- Prénom -->
                        <td>
                            <input type="text"
                                [ngModelOptions]="{standalone: true}"
                                class="form-control custom-input"
                                style="min-width:150px"
                                placeholder="Prénom"
                                autocomplete="off"
                                [(ngModel)]="item.prenom" />
                        </td>

                        <!-- Genre -->
                        <td style="min-width:100px;">
                            <ng-select
                                [ngModelOptions]="{standalone: true}"
                                [(ngModel)]="item.genre"
                                [clearable]="false"
                                placeholder="—"
                                style="font-size:.8rem;">
                                <ng-option value="M">
                                    <i class="fa fa-mars mr-1" style="color:#3b82f6;"></i> Masculin
                                </ng-option>
                                <ng-option value="F">
                                    <i class="fa fa-venus mr-1" style="color:#ec4899;"></i> Féminin
                                </ng-option>
                            </ng-select>
                        </td>

                        <!-- Statut -->
                        <td style="min-width:130px;">
                            <ng-select
                                [ngModelOptions]="{standalone: true}"
                                [(ngModel)]="item.statut"
                                [clearable]="false"
                                placeholder="—"
                                style="font-size:.8rem;">
                                <ng-option *ngFor="let s of itemsStatut" [value]="s.codification">
                                    <i class="fa fa-circle mr-1"
                                        [style.color]="s.codification === 'A'   ? '#10b981' :
                                                        s.codification === 'C'   ? '#3b82f6' :
                                                        s.codification === 'E'   ? '#f59e0b' :
                                                        s.codification === 'ASC' ? '#8b5cf6' :
                                                        s.codification === 'AUT' ? '#9ca3af' : '#6b7280'">
                                    </i>{{ s.libelle }}
                                </ng-option>
                            </ng-select>
                        </td>

                        <!-- Affections (masqué par défaut) -->
                        <td *ngIf="showExtraColumns" style="min-width:160px;">
                            <ng-select
                                [ngModelOptions]="{standalone: true}"
                                [(ngModel)]="item.affections_list"
                                [multiple]="true"
                                [closeOnSelect]="false"
                                [clearable]="true"
                                placeholder="Affections"
                                style="font-size:.8rem;"
                                (change)="onAffectionChange(item)">
                                <ng-template ng-multi-label-tmp let-items="items">
                                    <span class="ng-value-label">{{ items.length }} sélectionné(s)</span>
                                </ng-template>
                                <ng-option *ngFor="let a of itemsAffection" [value]="a.codification">
                                    {{ a.libelle }}
                                </ng-option>
                            </ng-select>
                        </td>

                        <!-- Matricule Assuré -->
                        <td>
                            <input type="text"
                                (input)="autoFillFamillyParentMatricule(item)"
                                [ngModelOptions]="{standalone: true}"
                                class="form-control custom-input"
                                placeholder="Matricule"
                                autocomplete="off"
                                [(ngModel)]="item.matricule_assure" />
                        </td>

                        <!-- Numéro CNAM (masqué par défaut) -->
                        <td *ngIf="showExtraColumns">
                            <input type="text"
                                [ngModelOptions]="{standalone: true}"
                                class="form-control custom-input"
                                placeholder="N° CNAM"
                                autocomplete="off"
                                [(ngModel)]="item.numero_cnam" />
                        </td>

                        <!-- Date naissance -->
                        <td>
                            <input type="text" placeholder="JJ/MM/AAAA" autocomplete="off"
                                class="form-control" bsDatepicker
                                [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY', containerClass: 'theme-dark-blue' }"
                                [(ngModel)]="item.date_naissance"
                                [ngModelOptions]="{standalone: true}" />
                        </td>

                        <!-- Date entrée -->
                        <td>
                            <input type="text" placeholder="JJ/MM/AAAA" autocomplete="off"
                                class="form-control" bsDatepicker
                                [bsConfig]="{ dateInputFormat: 'DD/MM/YYYY', containerClass: 'theme-dark-blue' }"
                                [(ngModel)]="item.date_entree"
                                [ngModelOptions]="{standalone: true}" />
                        </td>

                        <!-- Téléphone -->
                        <td>
                            <input type="tel"
                                [ngModelOptions]="{standalone: true}"
                                class="form-control custom-input"
                                placeholder="Téléphone"
                                autocomplete="off"
                                [(ngModel)]="item.telephone" />
                        </td>

                        <!-- Email (masqué par défaut) -->
                        <td *ngIf="showExtraColumns">
                            <input type="email"
                                [ngModelOptions]="{standalone: true}"
                                class="form-control custom-input"
                                placeholder="Email"
                                autocomplete="off"
                                [(ngModel)]="item.email" />
                        </td>

                        <!-- Email 2 (masqué par défaut) -->
                        <td *ngIf="showExtraColumns">
                            <input type="email"
                                [ngModelOptions]="{standalone: true}"
                                class="form-control custom-input"
                                placeholder="Email 2"
                                autocomplete="off"
                                [(ngModel)]="item.email2" />
                        </td>

                        <!-- Photo -->
                        <td>
                            <div class="text-center">
                                <img *ngIf="item?.file_data?.fullImg"
                                    [src]="item.file_data.fullImg"
                                    alt="Photo" class="img-thumbnail mb-1"
                                    style="width:40px;height:40px;object-fit:cover;" />
                                <input [id]="'img-' + i" type="file" class="d-none"
                                    (change)="uploadBenefImageFile($event)"
                                    accept=".png,.jpg,.jpeg,.bmp" />
                                <label [for]="'img-' + i" (click)="currentBenef = item"
                                    class="btn btn-sm btn-outline-secondary d-block mb-0"
                                    style="cursor:pointer;font-size:.72rem;padding:2px 6px;">
                                    <i class="fa fa-camera"></i>
                                </label>
                            </div>
                        </td>

                        <!-- Supprimer -->
                        <td class="text-center">
                            <button type="button"
                                class="btn btn-sm btn-link text-danger p-0"
                                (click)="itemsToSaveBenef.splice(i, 1)">
                                <i class="fa fa-trash"></i>
                            </button>
                        </td>
                    </tr>

                    <tr *ngIf="itemsToSaveBenef?.length === 0">
                        <td colspan="12" class="text-center text-muted py-4">
                            Aucun bénéficiaire ajouté
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="mt-2">
            <button type="button" class="btn btn-sm btn-outline-success" (click)="addRow()">
                <i class="fa fa-plus mr-1"></i>Ajouter une ligne
            </button>
        </div>
    </form>
</div>

<div class="modal-footer modal-footer-custom">
    <div class="d-flex justify-content-end gap-2 w-100">
        <button 
            type="button"
            class="btn btn-md btn-cancel"
            (click)="bsModalRef.hide()">
            Fermer
        </button>
        
        <button 
            type="button"
            (click)="confirmSaveItemMassData(itemToSave)"
            class="btn btn-md custom_btn_primary"
            [class.auth-spinner]="loading"
            [disabled]="loading || itemsToSaveBenef?.length === 0">
            Sauvegarder
        </button>
    </div>
</div>